import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommFormGroupByVendor extends Layout {
    buttonCopy: Button;
    buttonExApps: Button;
    buttonNewForm: Button;
    buttonUpload: Button;
    horizontalspacer1: HorizontalSpacer;
    labelVendorName: Label;
    panelTaskFilters: Panel;
    panelVendorName: Panel;
    sourceMobileCommFormByVendor: DataSource;
    tableFormByVendor: Table;
}
